<template>
  <div id="search-form-spacer" class="spacer">
    <span class="spacer-line"></span>
    <span class="spacer-or">OR</span>
    <span class="spacer-line"></span>
  </div>
</template>

<script>
export default {
  name: 'SearchFormSpacer',
}
</script>

<style scoped lang="scss">
#search-form-spacer {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;

  .spacer-line {
    flex: 1;
    height: 1px;
    background-color: #ccc;
  }

  .spacer-or {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    flex-shrink: 0;
    background-color: #000;
    color: #fff;
    font-family: "Gill Sans", "Inter", sans-serif;
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1;
    text-transform: uppercase;
    border-radius: 50%;
  }
}
</style>
